"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.$sendDTMF = exports.$refuseRoom = exports.$postRoomLeave = exports.$postRoomKicks = exports.$postRoomJoin = exports.$postRoomInvites = exports.$postRoom = exports.$patchRoomRecording = exports.$patchRoomJoin = exports.$patchRoomAlive = exports.$patchRoom = exports.$ignoreRoom = exports.$headRoom = exports.$getRoomsDestinations = exports.$getRooms = exports.$getRoomFeed = exports.$getRoom = exports.$forwardRoom = exports.$deleteRoom = exports.$cleanFeeditems = exports.$acceptRoom = void 0;
var _oldHttpClient = require("../../apiClient/oldHttpClient");
var base = '/rooms';
var $acceptRoom = (_room, _client) => (0, _oldHttpClient.apiClient)({
  method: 'patch',
  url: "".concat(base, "/").concat(_room, "/takeoff"),
  body: {
    _client
  }
});
exports.$acceptRoom = $acceptRoom;
var $deleteRoom = _room => (0, _oldHttpClient.apiClient)({
  method: 'delete',
  url: "".concat(base, "/").concat(_room)
});
exports.$deleteRoom = $deleteRoom;
var $forwardRoom = (_room, _destRoom, destNumber, _destUser) => (0, _oldHttpClient.apiClient)({
  method: 'post',
  url: "".concat(base, "/").concat(_room, "/transfer"),
  body: {
    _destRoom,
    destNumber,
    _destUser
  }
});
exports.$forwardRoom = $forwardRoom;
var $patchRoomAlive = (_room, _client) => (0, _oldHttpClient.apiClient)({
  method: 'patch',
  url: "".concat(base, "/").concat(_room, "/keep-responder-alive"),
  body: {
    _client
  }
});
exports.$patchRoomAlive = $patchRoomAlive;
var $getRoom = _room => (0, _oldHttpClient.apiClient)({
  method: 'get',
  url: "".concat(base, "/").concat(_room)
});
exports.$getRoom = $getRoom;
var $headRoom = _room => (0, _oldHttpClient.apiClient)({
  method: 'head',
  url: "".concat(base, "/").concat(_room)
});
exports.$headRoom = $headRoom;
var $getRoomFeed = _room => (0, _oldHttpClient.apiClient)({
  method: 'get',
  url: "".concat(base, "/").concat(_room, "/feed")
});
exports.$getRoomFeed = $getRoomFeed;
var $getRooms = () => (0, _oldHttpClient.apiClient)({
  method: 'get',
  url: base
});
exports.$getRooms = $getRooms;
var $getRoomsDestinations = _room => (0, _oldHttpClient.apiClient)({
  method: 'get',
  url: "".concat(base, "/").concat(_room, "/transfer")
});
exports.$getRoomsDestinations = $getRoomsDestinations;
var $ignoreRoom = (_room, _client) => (0, _oldHttpClient.apiClient)({
  method: 'patch',
  url: "".concat(base, "/").concat(_room, "/ignore"),
  body: {
    _client
  }
});
exports.$ignoreRoom = $ignoreRoom;
var $patchRoom = (_room, room) => (0, _oldHttpClient.apiClient)({
  method: 'patch',
  url: "".concat(base, "/").concat(_room),
  body: room
});
exports.$patchRoom = $patchRoom;
var $patchRoomJoin = (_room, _client, audio, video, screenSharing, hold, triggeredBy) => (0, _oldHttpClient.getAxiosProvider)()({
  method: 'patch',
  url: "".concat(base, "/").concat(_room, "/join"),
  data: {
    _client,
    audio,
    video,
    screenSharing,
    hold
  },
  params: {
    triggeredBy
  }
});
exports.$patchRoomJoin = $patchRoomJoin;
var $patchRoomRecording = (_room, _client, recordingState) => (0, _oldHttpClient.apiClient)({
  method: 'patch',
  url: "".concat(base, "/").concat(_room, "/join"),
  body: {
    _client,
    recordingState
  }
});
exports.$patchRoomRecording = $patchRoomRecording;
var $postRoom = body => (0, _oldHttpClient.apiClient)({
  method: 'post',
  url: "".concat(base),
  body
});
exports.$postRoom = $postRoom;
var $postRoomInvites = (_room, _users, destNumbers) => (0, _oldHttpClient.apiClient)({
  method: 'post',
  url: "".concat(base, "/").concat(_room, "/invite"),
  body: {
    _users,
    destNumbers
  }
});
exports.$postRoomInvites = $postRoomInvites;
var $postRoomJoin = (_room, _client, audio, video, _device) => (0, _oldHttpClient.apiClient)({
  method: 'post',
  url: "".concat(base, "/").concat(_room, "/join"),
  body: {
    _client,
    audio,
    video,
    _device
  }
});
exports.$postRoomJoin = $postRoomJoin;
var $postRoomKicks = (_room, _users) => (0, _oldHttpClient.apiClient)({
  method: 'post',
  url: "".concat(base, "/").concat(_room, "/kick"),
  body: {
    _users
  }
});
exports.$postRoomKicks = $postRoomKicks;
var $postRoomLeave = (_room, _user, _client) => (0, _oldHttpClient.apiClient)({
  method: 'post',
  url: "".concat(base, "/").concat(_room, "/leave/").concat(_user),
  body: {
    _client
  }
});
exports.$postRoomLeave = $postRoomLeave;
var $refuseRoom = (_room, _client) => (0, _oldHttpClient.apiClient)({
  method: 'patch',
  url: "".concat(base, "/").concat(_room, "/refuse"),
  body: {
    _client
  }
});
exports.$refuseRoom = $refuseRoom;
var $sendDTMF = (_room, digit) => (0, _oldHttpClient.apiClient)({
  method: 'post',
  url: "".concat(base, "/").concat(_room, "/dtmf"),
  body: {
    digit
  }
});
exports.$sendDTMF = $sendDTMF;
var $cleanFeeditems = _room => (0, _oldHttpClient.apiClient)({
  method: 'post',
  url: "".concat(base, "/").concat(_room, "/empty-chat")
});
exports.$cleanFeeditems = $cleanFeeditems;